import EventEmitter from 'events';
import Logger from '../Logger';

/**
 * Manage media content and output it to video element
 */
export default class MediaContentManager extends EventEmitter {
    /**
     * creates instance of MediaContentManager
     * @param{Stream} stream which should be visualized and managed
     * @param{Object} videoElement already defined video element
     * @param{ConfigurationManager} configurationManager entity to get configuration
     */
    constructor(stream, videoElement, configurationManager) {
        super();
        this.stream = stream;
        this.logger = new Logger('REC-MCM', configurationManager.isDebugMode());
        this.usedContainers = [];

        const outputElement = videoElement || document.createElement('video');
        this.currentVideoOutput = outputElement;
        outputElement.id = 're-test-output';
        outputElement.muted = true;

        outputElement.autoplay = true;
        outputElement.playsinline = '';
        outputElement.setAttribute('playsinline', ''); // safari-mobile-compatibility
        outputElement.setAttribute('muted', ''); // safari-mobile-compatibility

        if (this.stream) {
            this.logger.logDebug('Stream for test exist');
            if (window.URL && window.URL.createObjectURL) {
                // backward-compatibility
                outputElement.srcObject = this.stream.pluginStream.gumStream;
            }

            const loadedMetadataHandler = () => {
                outputElement.play();
                this.logger.logDebug('stream metadata received!');
                this.emit('play', outputElement);
            };

            if (outputElement.onloadedmetadata) {
                outputElement.onloadedmetadata = loadedMetadataHandler;
            }

            outputElement.addEventListener('loadedmetadata', loadedMetadataHandler);
            outputElement.srcObject = this.stream.pluginStream.gumStream;
        }
    }

    /**
     * Attachs video element to provided container
     * @param{string} containerId is id of container where video should be append
     * @return {Promise<Object>}
     */
    attachToContainer(containerId) {
        return new Promise((resolve, reject) => {
            if (containerId) {
                this.logger.logDebug(`container id was provided: ${containerId}`);
                const parentEl = document.querySelector(`#${containerId}`);
                if (parentEl) {
                    parentEl.appendChild(this.currentVideoOutput);
                    this.usedContainers.push(parentEl);
                    this.logger.logDebug(`video element has been added to parent ${containerId}`);
                    resolve(parentEl);
                } else {
                    reject(new Error(`container with id: "${containerId}" was not found!`));
                }
            } else {
                reject(new Error('containerId is not provided!'));
            }
        });
    }

    /**
     * removes the video output element from all parent elements where it was attached
     * @return {Promise<boolean>}
     */
    deattachFromAllContainers() {
        this.usedContainers.forEach((el) => {
            el.removeChild(this.currentVideoOutput);
        });
        this.currentVideoOutput = null;
        return Promise.resolve(true);
    }
}
